module.exports = __webpack_public_path__ + "img/IMG_1861.68083f05.jpg";